import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Can I manage High Court and District Court matters together?",
    a: "Yes. You add the court, bench and court room for each hearing yourself, so the same diary covers High Court, District and Sessions, Magistrate courts and tribunals such as NCLT, DRT and consumer forums.",
  },
  {
    q: "What happens when the 30-day trial ends?",
    a: "Nothing is charged unless you choose to subscribe. If you do not continue, the account moves to the Free plan and your data remains. You can cancel a paid plan any time from Settings.",
  },
  {
    q: "Who can see my case files and documents?",
    a: "Only signed-in members of your own firm. Every record is scoped to your organisation, and documents are never served from a public link — each download is authorised against your account.",
  },
  {
    q: "Can a client see my private notes?",
    a: "No. The client portal is read-only and shows a client only their own matter and the updates you publish. Your notes, other clients and firm data are not visible there.",
  },
  {
    q: "Does it work on a phone inside court?",
    a: "Yes. The diary, case list and hearing details are built to be read on a phone, so you can check the next date and mark an adjournment without waiting to get back to chambers.",
  },
  {
    q: "How do I pay, and is it secure?",
    a: "Payments run through Razorpay, so your card details are handled by the gateway and never stored by Advocate Diary. Monthly and yearly billing are both available.",
  },
];

export const Faq = () => (
  <section
    id="faq"
    data-testid="landing-faq"
    className="border-b border-border bg-white px-4 py-16 sm:px-6 sm:py-20 lg:px-8"
  >
    <div className="mx-auto max-w-3xl">
      <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark">Questions</p>
      <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-navy sm:text-4xl">
        Before you sign up
      </h2>

      <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-sans text-base text-navy hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
